import React, { useState } from "react";
import { Button, Modal } from "flowbite-react";
import { API_BASE_URL, STRIPE_PUBLIC_KEY } from "../../config";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const AgregarTarjetaModal = ({ clienteId, onTarjetaRegistrada }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button 
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        onClick={() => setShowModal(true)}
      >
        Registrar Tarjeta
      </Button>
      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <Modal.Header>Registrar Tarjeta</Modal.Header>
        <Modal.Body>
          <p className="text-gray-700 mb-3">Ingresa los datos de tu tarjeta para procesar pagos en SalyCome.</p>
          <Elements stripe={stripePromise}>
            <FormularioAgregarTarjeta 
              clienteId={clienteId} 
              onSuccess={() => {
                setShowModal(false);
                onTarjetaRegistrada();
              }} 
            />
          </Elements>
        </Modal.Body>
      </Modal>
    </>
  );
};

const FormularioAgregarTarjeta = ({ clienteId, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!stripe || !elements) {
      setError("Stripe no está disponible.");
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    
    // 📌 Generar el token de la tarjeta
    const { token, error } = await stripe.createToken(cardElement);
    
    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/clientes/${clienteId}/agregar-tarjeta`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token.id }), // ✅ Se envía el token correctamente
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Error al registrar la tarjeta");
      }

      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="p-3 border rounded bg-white">
        <CardElement className="p-2 text-gray-700" />
      </div>
      {error && <p className="text-red-500">{error}</p>}
      <Button 
        type="submit" 
        disabled={loading || !stripe}
        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
      >
        {loading ? "Procesando..." : "Registrar Tarjeta"}
      </Button>
    </form>
  );
};

export default AgregarTarjetaModal;
